import { BoxChart } from '../../../../../../components/Charts/BoxChart'
import { GroupByTime, UUID } from '@indigohive/cogfy-types'
import { GetExecutionCollectionGroupedByTimeQuery } from '@indigohive/cogfy-types/endpoints/getExecutionCollectionGroupedByTime'
import { HeaderComponent } from './HeaderComponent'
import { LineChart } from '../../../../../../components/Charts/LineChart'
import { useCogfy } from '../../../../../../hooks'
import { useQuery } from '@tanstack/react-query'
import { useState } from 'react'
import { useTranslation } from 'react-i18next'

export type CreditsUsageChartProps = {
  startDate?: Date
  endDate?: Date
  collectionId?: UUID
}

export function CreditsUsageChart (props: CreditsUsageChartProps) {
  const { startDate, endDate, collectionId } = props

  const { t } = useTranslation()
  const cogfy = useCogfy()

  const [groupBy, setGroupBy] = useState<GroupByTime>('hour')

  const query: GetExecutionCollectionGroupedByTimeQuery = {
    timezoneOffset: new Date().getTimezoneOffset() / -60,
    groupBy,
    startDate,
    endDate,
    collectionId
  }

  const getTasks = useQuery({
    queryKey: ['getExecutionCollectionGroupedByTime', query, 2],
    queryFn: ({ signal }) => cogfy.getExecutionCollectionGroupedByTime(query, { signal })
  })

  const labels = getTasks.data?.flatMap(row => row.label)

  const dataCogfyCredits = {
    labels,
    datasets: [
      {
        label: 'Cogfy credits',
        data: getTasks.data?.flatMap(item => item.credits) || [],
        borderColor: '#37cdbe',
        backgroundColor: '#37cdbe'
      }
    ]
  }

  return (
    <BoxChart
      title={t('workspaceUsagePage:Credits usage by period')}
      headerComponent={
        <HeaderComponent
          groupBy={groupBy}
          setGroupBy={setGroupBy}
        />
      }
    >
      <LineChart
        className="min-h-[400px]"
        data={dataCogfyCredits}
        loading={getTasks.isLoading}
        error={getTasks.isError}
      />
    </BoxChart>
  )
}
